/** Running view “Campaign started”. */
const wizRunEN = {
  wizRunWorking: 'Agent at work',
  wizRunDraftPill: 'Draft',
  wizRunDonePill: 'Agent is done',
  wizRunPausedPill: 'Paused',
  wizRunPending: 'Approve {{count}} messages',
  wizRunNothing: 'Nothing for you to do',
  wizRunPause: 'Pause',
  wizRunResume: 'Resume',
  wizRunToOverview: 'To overview',
  wizRunWhatNow: 'What happens now',
  wizRunApproveNow: 'Approve messages now',
  wizRunStatFound: 'Found',
  wizRunStatFit: 'Fitting',
  wizRunStatContacted: 'Contacted',
  wizRunAgentTitle: 'How the agent works',
  wizRunChange: 'Change',
  wizRunChangeCampaignTitle: 'Change the campaign criteria',
  wizRunChangeCampaign: 'Change campaign',
  wizRunLoading: 'Loading status …',
  wizRunLoadError: 'The campaign status could not be loaded.',
  wizRunStatusError: 'The status could not be changed.',
};
export default wizRunEN;
